const pad = (n: number): string => String(n).padStart(2, '0');

/** The viewer's own calendar date `offsetDays` from today, as `YYYY-MM-DD`,
 *  read from the browser's clock. */
export function viewerDate(offsetDays = 0, now: Date = new Date()): string {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offsetDays);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
